/**
 * @constant BsUtilEmptySelection Constant for empty selection
 */
export const BsUtilEmptySelection = {
    id: "0",
    marketId: "0",
    group: 0,
    name: "",
    title: "",
    betslipLine: "",
    participantMapping: "",
    displayOdds: {},
    trueOdds: 0,
    points: 0,
    isDisabled: false,
    tags: [],
    metadata: {
        idSBTech: "0",
        type: "0"
    },
    status: ""
};
//# sourceMappingURL=BsUtilEmptySelection.js.map